import type {Pinia} from "pinia";

export default defineNuxtPlugin(async ({$pinia}) => {
    const {user, refresh, isLoggedIn} = useAuthStore($pinia as Pinia);
    const taxStore = useTaxStore($pinia as Pinia);

    // Skip if already initialized on server
    if (user !== undefined) return;

    // First ensure authentication works
    await refresh();
    
    // Then try to fetch tax rates, but don't block auth flow if it fails
    taxStore.fetchRates().catch(() => {
        console.log('Tax rates fetch failed, but auth flow continues');
    });
    
    if (isLoggedIn) {
        const {setLocale} = useI18n()
        setLocale(user?.settings.locale ?? 'en_US')
    }
});